(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/toUpper', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/toUpper'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.toUpper, global.convert);
    global.toUpper = mod.exports;
  }
})(this, function (exports, _toUpper2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.toUpper = undefined;

  var _toUpper3 = _interopRequireDefault(_toUpper2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Converts string, as a whole, to upper case just like String#toUpperCase.
   * @function
   * @memberof string
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @return {Object} Returns the updated object.
   * @example toUpper({ nested: { a: "a string" } }, 'nested.a') // => { nested: { a: "A STRING" } }
   * @see {@link https://lodash.com/docs#toUpper|lodash.toUpper} for more information.
   * @see {@link https://mdn.io/String/toUpperCase|String.toUpperCase} for more information.
   * @since 0.3.0
   */
  var toUpper = (0, _convert.convert)(_toUpper3.default);
  exports.toUpper = toUpper;
  exports.default = toUpper;
});